import * as React from "react";
const SvgLeftArrow = props => <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m8 5-5 5 5 5m9-5h-14" style={{
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "currentcolor"
  }} /></svg>;
export default SvgLeftArrow;